export const getHelperAndTooltip = ({ intl, selectedRole, isTaskRole }) => {
  if (!selectedRole) {
    return {
      helperText: intl.formatMessage(
        {
          id: 'rateCard.helperText.roleNotSelected'
        },
        { isTaskRole }
      ),
      tooltip: intl.formatMessage(
        {
          id: 'rateCard.toolTip.roleNotSelected'
        },
        { isTaskRole }
      )
    };
  }

  if (!selectedRole.isInRateTable) {
    return {
      helperText: intl.formatMessage(
        {
          id: 'rateCard.helperText.roleNotOnRateCard'
        },
        { isTaskRole }
      ),
      tooltip: intl.formatMessage(
        {
          id: 'rateCard.toolTip.roleNotOnRateCard'
        },
        { isTaskRole }
      )
    };
  }

  return {
    helperText: '',
    tooltip: ''
  };
};
